<template>
  <div class="paper-example">
    <h1>2019届高三历史人教版一轮复习考点集训：考点41   物质生活和习俗的变迁</h1>
    <div class="paper-body">
      <question-box v-for="(question,index) in questions" :question="question" :key="index"></question-box>
    </div>
  </div>
</template>
<script type="text/babel">

  import questionBox from '../../../../../components/question/question-box.vue';

  export default {
    components: {
      questionBox
    },
    data: function() {
      return {
        questions:[
          {
            "id": 11973376,
            "stem": "<p style=''><span style=\"font-size: 16px;font-family: 宋体;\" >张德彝在《航海述奇》里记载了1866年他从天津到上海途中吃西餐的事情：“每日三次点心，两次大餐……所食者，有烧炙，牛羊鸡鱼，再则糖饼、苹果……饮则凉水、糖水、热牛奶、菜肉汤、甜苦洋酒。”材料说明当时</span></p>",
            "options": {
              "A": "<span style=\"\" >西餐种类繁多、营养卫生</span>",
              "B": "<span style=\"\" >西餐已成为中华饮食文化的主流</span>",
              "C": "<span style=\"\" >西餐馆主要分布在沿海通商口岸</span>",
              "D": "<span style=\"\" >西餐馆在内地普遍出现</span>"
            },
            "difficult": {
              "id": 3,
              "name": "一般"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-09-11T22:03:04",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [

            ],
            "childrenList": [

            ],
            "answer": "C",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：本题主要考查近代社会习俗的变化。依据所学可知，材料所反映的吃西餐的情况只可能出现在通商口岸，且是少数人的行为。所以C项符合题意。A、B、D三项史实不符。所以选C。</span><p style=''>考点：中国近现代社会生活的变迁•物质生活与习俗的变迁•表现</p></span>"
          },
          {
            "id": 11997824,
            "stem": "<p style=''>1905年《时报》报道了一对青年婚礼的流程：一、来宾入场。二、新人入场。三、新人行结婚礼,相对三揖。四、唱歌奏乐。五、证人曹君宣读证书。六、来宾祝词。七、来宾演说。八、唱歌散会。”其反映当时一些地区婚礼（  ）</p>",
            "options": {
              "A": "保留了较多传统",
              "B": "奢靡之风兴起",
              "C": "向近代文明转变",
              "D": "仪式较为繁琐"
            },
            "difficult": {
              "id": 4,
              "name": "较难"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-08-30T01:09:11",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [

            ],
            "childrenList": [

            ],
            "answer": "C",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：本题考查学生获取和解读信息的能力。通过材料可以看到这是一场新式婚礼，反映了清末，一批先进的青年男女主张婚姻自主。婚姻仪式也由繁到简，向近代文明转变。故选C项。</span><p style=''>考点：中国近代社会生活的变迁·物质生活和社会习俗的变迁·社会习俗的变迁</p></span>"
          },
          {
            "id": 12016618,
            "stem": "<p style=''>“诸君诸君，发辫之害如此，虽欲不变通之其可已乎！戊戌推翻新政，一蹶不振，论者多咎变法之初不先变发。发短不可以骤长，不可以骤长，则面目形状既变，衣服装束不得不随之而变，衣服装束变，而行为政治皆不得不变矣。”此言论</p>",
            "options": {
              "A": "认识到风俗变迁与社会发展间存在联系",
              "B": "为戊戌变法时期资产阶级维新派所提出",
              "C": "科学地指出了中国社会落后的根本原因",
              "D": "表明当时国人已充分认识到蓄辫的危害"
            },
            "difficult": {
              "id": 5,
              "name": "困难"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-09-11T06:43:03",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [

            ],
            "childrenList": [

            ],
            "answer": "A",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：本题材料提到：“诸君诸君，发辫之害如此，虽欲不变通之其可已乎！戊戌推翻新政，一蹶不振，论者多咎变法之初不先变发。衣服装束不得不随之而变，衣服装束变，而行为政治皆不得不变矣。”。结合所学知识可知，风俗变迁与社会发展间存在密切联系，因此选A。BCD都不符合材料信息，排除。</span><p style=''>考点：中国近代社会生活的变迁·物质生活与习俗的变迁·特点</p></span>"
          },
          {
            "id": 12036513,
            "stem": "<p style=''>1912年，政府在新颁布的学制及各类学校条例中，提倡医学专门学校（西医），摒中医于政府教育体系之外，由此引发了民间有关中西医的论争长达10多年。这反映出（  ）</p>",
            "options": {
              "A": "传统教育的近代化转型",
              "B": "科学精神深入人心",
              "C": "异质文化的冲突与融合",
              "D": "官民立场尖锐对立"
            },
            "difficult": {
              "id": 3,
              "name": "一般"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-08-26T10:39:33",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [

            ],
            "childrenList": [

            ],
            "answer": "C",
            "analysis": "<span class=\"qml-general\">试题分析：本题考查中西文化的冲突。根据题干时间1912年和材料“中西医的论争长达10多年”可知民国时期随着西方文化的传入，中西文化的碰撞和冲突加剧，中西医之争就是其中一个方面，说明了外来文化和本土文化的冲突与融合，故选C项。材料的落脚点在中西医之争而不是教育问题，故排除A项。B、D两项材料体现不出来，排除。</span>"
          },
          {
            "id": 12058503,
            "stem": "<p style=''>清末的上海，“无论其为官为商为士为民，但得稍有赢余，即莫不竟以衣服炫耀为务，即下至娼优隶卒，就其外貌观之，俨然望族之家。”民国初年，这种社会现象较之清末更是有过之而无不及，这种变化对社会发展的主要影响是（  ）</p>",
            "options": {
              "A": "使奢靡之风逐渐盛行",
              "B": "有利于生活习俗西化",
              "C": "淡化了传统等级观念",
              "D": "社会上交际活动增加"
            },
            "difficult": {
              "id": 5,
              "name": "困难"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-08-28T04:47:07",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [
              {
                "id": 25765,
                "name": "第四单元 中国近现代社会生活的变迁",
                "pathIds": "25765",
                "textbookId": 1187
              },
              {
                "id": 26257,
                "name": "第五单元 中国近现代社会生活的变迁",
                "pathIds": "26257",
                "textbookId": 1160
              },
              {
                "id": 26552,
                "name": "专题四 中国近现代社会生活的变迁",
                "pathIds": "26552",
                "textbookId": 1178
              }
            ],
            "knowledgePoints": [
              {
                "id": 9999,
                "name": "物质生活与习俗的变迁",
                "pathIds": "9865,9998,9999",
                "subjectId": 33
              }
            ],
            "childrenList": [

            ],
            "answer": "C",
            "analysis": "<span class=\"qml-general\">试题解析：本题主要考查中国近代物质生活和社会习俗的变化，主要考查学生从材料提取重要信息进行分析的能力。中国古代，服装是人的社会地位和身份的象征，而到了近代，只要具备经济条件，就可以穿得很好，无论地位高低以及从事何种工作，从社会作用来分析，说明了服装使传统的等级尊卑观念发生了改变，C项正确;ABD三项表述材料都不能反映，均排除。故选C。</span>"
          },
          {
            "id": 12061102,
            "stem": "<p style=''>近代中国交谊舞最初还局限于上流社会的少数人，但到20世纪20年代初，跳舞之风在北京、上海等大城市兴起。早年认为男女合群手舞足蹈“男女杂沓，大败风纪”“与中国美俗良法有所背离”避而不观的中国人，随跳舞潮流由临海一带向内陆澎湃涌来，其旧有之念渐次华离犋碎（支离破碎）。这反映了（  ）</p>",
            "options": {
              "A": "西方生活方式冲击了国人的传统观念",
              "B": "儒家的传统观念被国人完全抛弃",
              "C": "辛亥革命使民主平等思想深入人心",
              "D": "国人接受西方生活方式全盘西化"
            },
            "difficult": {
              "id": 3,
              "name": "一般"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-08-26T11:10:11",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [
              {
                "id": 9999,
                "name": "物质生活与习俗的变迁",
                "pathIds": "9865,9998,9999",
                "subjectId": 33
              }
            ],
            "childrenList": [

            ],
            "answer": "A",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：本题考查学生调动和运用所学知识的能力。注意“其旧有之念渐次华离犋碎”，结合所学知识，交谊舞源于西方生活方式，传入中国后逐渐被人们接受，说明西方生活方式冲击了国人的传统观念 ，A项正确，C项错误；B D两项过于绝对化。故选A项。</span><p style=''>考点：中国近现代社会生活的变迁·物质生活和社会习俗的变化·社会习俗的变化</p></span>"
          },
          {
            "id": 12062060,
            "stem": "<p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >1983年，新华社发表《服装模式宜解放》的评论，提倡男同志穿西服，女同志穿旗袍、西装裙子，服装款式要大方，富有民族特色．评论表明了怎样的舆论导向</span></p>",
            "options": {
              "A": "倡导革新服饰推动生活文明化",
              "B": "推进思想解放为改革开放开路",
              "C": "学习西方同时注重维护民族传统",
              "D": "促进服装行业适应外向型经济"
            },
            "difficult": {
              "id": 4,
              "name": "较难"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-08-26T11:24:30",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [
              {
                "id": 9999,
                "name": "物质生活与习俗的变迁",
                "pathIds": "9865,9998,9999",
                "subjectId": 33
              }
            ],
            "childrenList": [

            ],
            "answer": "B",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：服饰是一个时期社会风貌的体现。本题的关键信息是“1983年”，这个时候，我国改革开放刚刚起步，需要进一步解放思想。所以新华社发表《服装模式宜解放》，作者是想通过服饰模式的解放，来促进人们的思想解放，进而推动中国的改革开放，故选B。西服、旗袍、西装裙子与传统中式服装只是服装模式的不同，文化传统的不同，但不能作为评判生活文明与否的标准，故A项错误；学习西方同时注重维护民族传统与材料内容无关，材料提倡穿西服、穿旗袍、西装裙子，故C项错误； 材料中提倡的是中国人穿西服、旗袍、西装裙子，并非强调服装出口适应外向型经济，故D项错误． 故选B．</span><p style=''>考点： 现代中国的经济建设&middot;社会主义建设新时期&middot;改革开放</p><p style=''>【名师点睛】本题以服饰的变化入题，以服饰的解放来配合当时改革开放大潮，立意新颖。本题可采用采用社会史观来分析。社会史观主要指从社会的角度观察历史，从平民视角，以与人民息息相关的衣食住行等小角度来彰显社会进步。通常考查近现代中国社会生活的四次大变迁：第一次，1840年，鸦片战争以后； 第二次，1911年，辛亥革命后； 第三次，1949年，中华人民共和国成立后； 第四次，1978年，改革开放以后。</p></span>"
          },
          {
            "id": 12066596,
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >“新礼服兴，翎顶补服灭；剪发兴，辫子灭；爱国帽兴，瓜皮帽灭；天足兴，纤足灭；阳历兴，阴历灭；鞠躬礼兴，跪拜礼灭……”这首民谣反映了某个重大历史事件引起的社会风貌的变化。这一事件是</span></p>",
            "options": {
              "A": "<span style=\"\" >鸦片战争</span>",
              "B": "<span style=\"\" >戊戌变法</span>",
              "C": "<span style=\"\" >洋务运动</span>",
              "D": "<span style=\"\" >辛亥革命</span>"
            },
            "difficult": {
              "id": 4,
              "name": "较难"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-08-26T11:09:11",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [

            ],
            "childrenList": [

            ],
            "answer": "D",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：本题考查物质生活和社会习俗的变化，旨在考查学生解读信息、调动知识解决问题的能力。材料中的新现象“新礼服”、“剪发”、“爱国帽”、“废缠足”、“阳历”、“鞠躬”，联系所学知识可知，都与“辛亥革命”有关，D项正确。鸦片战争后，中国沿海城市出现了西方式的生活方式，但未出现剪辫易服、废止缠足的事件；戊戌变法时期，还未有“阳历”；洋务运动时期主张学习西方的先进科技，但在礼仪方面未涉及，A、B、C三项都不符合题意，均排除。</span><p style=''>考点： 中国近现代社会生活的变迁·物质生活和社会习俗的变迁·辛亥革命时期习俗的变迁</p></span>"
          },
          {
            "id": 12079104,
            "stem": "<p style='text-indent: 28px;line-height: 24px;'><span style=\"font-size: 14px;font-family: 楷体;\" >近代以来，人们的婚姻观念逐渐改变。阅读下列材料：</span></p><p style='text-indent: 28px;line-height: 24px;'><span style=\"font-size: 14px;font-family: 楷体;\" >材料一  父母之命这句话固然视为天经地义不可改易的，但是我们现在做父母的应该要晓得，这几千年来的礼教风俗到了今天决计行不通!……做父母的应该要明白些现在世界的大势!闭关自守，做不到了；农业经济组织下的状态，保不住了。</span></p><p style='margin-bottom: 13px;line-height: 24px;text-align: right;'><span style=\"font-family: 宋体;\" >——陆秋心《婚姻问题的三个时期》（《新妇女》1920年4月15日）</span></p><p style='text-indent: 28px;line-height: 24px;'><span style=\"font-size: 14px;font-family: 楷体;\" >材料二  我在小姊妹的帮忙下，加入了家庭妇联。我看见姊妹们加紧生产，努力学习文化，便愈感到自己的落后，我要好好地向姊妹们学习，我也加入了学习班。新婚姻法颁布以后，小姊妹张丽娟告诉我，说可以到家庭妇联申请向朱家离婚，婆婆没有理由阻拦我，于是我离婚了，我自由了。</span></p><p style='margin-bottom: 13px;line-height: 24px;text-align: right;'><span style=\"font-family: 宋体;\" >——《一个童养媳的新生》（1950年9月1日《解放日报》）</span></p><p style='text-indent: 28px;line-height: 24px;'><span style=\"font-size: 14px;font-family: 楷体;\" >材料三   婚姻不是件私事；……在任何地方一个男子或女子要得到一个配偶，没有不经过一番社会规定的手续。</span></p><p style='margin-bottom: 13px;line-height: 24px;text-align: right;'><span style=\"font-family: 宋体;\" >——费孝通《生育制度》</span></p><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >请回答：</span></p><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >（1）据材料一、二，人们的婚姻态度发生了怎样的变化?</span></p><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >（2）据材料一并结合所学知识，说明作为婚俗背景的经济基础和家庭关系，从传统到近代发生了怎样的变化?材料二中“我”的婚姻态度发生变化的社会条件是什么?</span></p><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >（3）据材料一、三，不同学者在婚姻自由度问题上的视角分别是什么?我们应如何全面认识这一问题?</span></p>",
            "options": null,
            "difficult": {
              "id": 3,
              "name": "一般"
            },
            "type": {
              "id": 3302,
              "name": "非选择题",
              "isSelectType": false
            },
            "updateTime": "2018-08-26T10:49:03",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [
              {
                "id": 25765,
                "name": "第四单元 中国近现代社会生活的变迁",
                "pathIds": "25765",
                "textbookId": 1187
              },
              {
                "id": 26257,
                "name": "第五单元 中国近现代社会生活的变迁",
                "pathIds": "26257",
                "textbookId": 1160
              },
              {
                "id": 26552,
                "name": "专题四 中国近现代社会生活的变迁",
                "pathIds": "26552",
                "textbookId": 1178
              }
            ],
            "knowledgePoints": [
              {
                "id": 9999,
                "name": "物质生活与习俗的变迁",
                "pathIds": "9865,9998,9999",
                "subjectId": 33
              }
            ],
            "childrenList": [

            ],
            "answer": "<span class=\"qml-an-sq\"><span class=\"qml-an\"><span style=\"font-size: 14px;font-family: 宋体;\" >（1）变化：从遵从父母之命到追求婚姻自由。</span><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >（2）经济基础：从传统小农经济到近代工商业的发展； </span></p><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >家庭关系：从传统纲常伦理（父为子纲）到家庭成员的平等自由；</span></p><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >社会条件：社会制度的变革（新中国的成立）；社团组织（家庭妇联）的支持；法律保障（新婚姻法的颁布）。</span></p><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >（3）视角：历史考察；社会关系考察。认识：随着社会的发展，婚姻当事人越来越自由，但处于社会关系中的人，婚姻自由总是相对的。</span></p></span></span>",
            "analysis": "<span class=\"qml-general\"><span style=\"font-family: 宋体;\" >第</span><span style=\"font-family: Times New Romance;\" >(1)</span><span style=\"font-family: 宋体;\" >小题从材料一看，当时人们的婚姻缔结以“父母之命”为主</span><span style=\"font-family: Times New Romance;\" >;</span><span style=\"font-family: 宋体;\" >而从材料二看，新婚姻法颁布后，人们的婚姻实现自由。</span><p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >第</span><span style=\"font-family: Times New Romance;\" >(2)</span><span style=\"font-family: 宋体;\" >小题从材料一看是在“农业经济组织下”，即小农经济基础上</span><span style=\"font-family: Times New Romance;\" >;</span><span style=\"font-family: 宋体;\" >后来，“闭关自守”做不到了，反映了近代开国与近代工业化的发展。从家庭关系看，则是由传统纲常伦理发展到平等自由。从社会条件看，主要是社会制度的变革、组织的支持和法律</span><span style=\"font-family: Times New Romance;\" >(</span><span style=\"font-family: 宋体;\" >新婚姻法</span><span style=\"font-family: Times New Romance;\" >)</span><span style=\"font-family: 宋体;\" >的保障。</span></p><p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >第</span><span style=\"font-family: Times New Romance;\" >(3)</span><span style=\"font-family: 宋体;\" >小题第一问从材料一和材料二看，一方面立足于历史发展的角度考查，另一方面则立足于人们的社会关系变化的角度考查。认识要从“婚姻自由度”的角度着手分析。一方面要看到婚姻越来越自由，另一方面也要看到这一自由是相对的，不是绝对的。</span></p></span>"
          },
          {
            "id": 16479922,
            "stem": "<p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >民国时期《大公报》曾刊登一则《离婚法论》卖书广告，称，“本书共二十余万言，有学说、有法条、有判例、有轶闻，足为解决离婚问题之圭臬，足供改进法律之参考。”对此解读最准确的是</span></p>",
            "options": {
              "A": "<span style=\"\" >西方法律逐渐影响中国</span>",
              "B": "<span style=\"\" >北洋政府加强法治建设</span>",
              "C": "<span style=\"\" >大公报注重提供法律帮助</span>",
              "D": "<span style=\"\" >婚姻观念中法律意识增强</span>"
            },
            "difficult": {
              "id": 2,
              "name": "较易"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-08-26T10:50:20",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [

            ],
            "childrenList": [

            ],
            "answer": "D",
            "analysis": "<span class=\"qml-general\"><span style=\"font-size: 14px;font-family: 宋体;\" >从材料中介绍的内容，《离婚法论》中介绍了有关离婚的学说、法条以及判例、轶闻，并不是正式的法律法规，因此无法体现西方法律影响中国以及北洋政府加强法治建设，所以排除A、B选项。C选项错误，《大公报》刊登的是一则广告，实质上是为了帮《离婚法论》宣传，并不是为民众提供法律援助。D选项说法正确，从书籍内容可以看出。</span></span>"
          },
          {
            "id": 16519097,
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 15px;font-family: 宋体;\" >民国时期，政府推行服饰改革，但洋装的流行并未取代传统中国样式，而是促成了中西合璧服装的产生。这种现象说明</span></p>",
            "options": {
              "A": "<span style=\"\" >以服饰为代表的西方先进文化传播困难</span>",
              "B": "<span style=\"\" >小农经济的存在使得生活方式难以改变</span>",
              "C": "<span style=\"\" >服饰变化反映了人们审美情趣不同</span>",
              "D": "<span style=\"\" >中国资本主义经济的发展仍然有限</span>"
            },
            "difficult": {
              "id": 3,
              "name": "一般"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-09-11T06:54:42",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [

            ],
            "childrenList": [

            ],
            "answer": "B",
            "analysis": "<span class=\"qml-general\"><span style=\"font-size: 14px;font-family: 宋体;\" >据材料并结合所学知识可知，洋装的流行不能取代传统中国样式的原因在于中国传统生活方式根深蒂固，而这种生活方式根源于小农经济占主导地位，故B选项正确；A选项错在“传播困难”， 材料无法体现西方先进文化在中国处于传播困难的局面，故A选项错误；服饰变化与人们审美情趣之间有密切联系，但审美情趣不是根本原因，故C选项错误；中西合璧服装的产生也不能说明中国资本主义经济的发展的程度，故D选项错误。故选B。</span></span>"
          },
          {
            "id": 16562150,
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >近代某一女性服饰样式1929年由中华民国政府确定为国家礼服之一，50年代以后被冷落，文革中被视为“资产阶级情调”遭受批判，1984年再次被定为女性外交人员礼服。该服装样式是(    )</span></p>",
            "options": {
              "A": "<span style=\"\" >传统满族旗袍</span>",
              "B": "<span style=\"\" >改良旗袍</span>",
              "C": "<span style=\"\" >苏式连衣裙</span>",
              "D": "<span style=\"\" >干部服</span>"
            },
            "difficult": {
              "id": 3,
              "name": "一般"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-08-26T11:04:18",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [

            ],
            "childrenList": [

            ],
            "answer": "B",
            "analysis": "<span class=\"qml-general\"><span style=\"font-size: 14px;font-family: 宋体;\" >孙中山民族主义，具有反满的特色，故A项错误；中华民国确定的礼服是近代中西合璧的旗袍，故B项正确；苏式连衣裙流行于新中国成立后，故C项错误；干部服流行于20世纪五十年代，故D项错误。</span><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >点睛：不同时代服装特点各异，但都透视所属时代的社会特点，可以推敲出当时的经济、政治、文化特征。</span></p></span>"
          },
          {
            "id": 16577904,
            "stem": "<p style=''><span style=\"font-size: 15px;font-family: 宋体;\" >1910年上海环球社出版的《图画日报•上海社会之现象》绘有“文明结婚之简便”一画：“自欧化东渐，一般新学界人，每崇尚自由婚姻，摒除中国旧时婚礼之繁。沪上素号开通，凡所谓文明结婚者，又数见不鲜。”这实际上反映了</span></p>",
            "options": {
              "A": "<span style=\"\" >近代中国妇女地位得到空前提高</span>",
              "B": "<span style=\"\" >传统的道德观念受到了冲击</span>",
              "C": "<span style=\"\" >中国传统的婚姻观念已完全改变</span>",
              "D": "<span style=\"\" >上海社会风气已经彻底西化</span>"
            },
            "difficult": {
              "id": 3,
              "name": "一般"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-08-26T11:35:11",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [

            ],
            "childrenList": [

            ],
            "answer": "B",
            "analysis": "<span class=\"qml-general\"><span style=\"font-size: 16px;font-family: 宋体;\" >据材料“文明结婚者，又数见不鲜”，并结合所学知识可知，中国旧时婚礼属于传统的道德观念，材料说明传统的道德观念受到了冲击，故B项正确；文明婚礼不能说明中国妇女地位得到空前提高</span><span style=\"font-size: 16px;font-family: Times New Roman;\" > </span><span style=\"font-size: 16px;font-family: 宋体;\" >，故</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >A</span><span style=\"font-size: 16px;font-family: 宋体;\" >项错误；</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >C</span><span style=\"font-size: 16px;font-family: 宋体;\" >项错在“已完全改变</span><span style=\"font-size: 16px;font-family: Times New Roman;\" > </span><span style=\"font-size: 16px;font-family: 宋体;\" >”，过于绝对，故</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >C</span><span style=\"font-size: 16px;font-family: 宋体;\" >项错误；材料也无法体现上海社会风气已经彻底西化，故D项错误。故选B。</span><p style='line-height: 24px;'><span style=\"font-size: 16px;font-family: 宋体;\" >点睛：本题解题过程中学生容易错选</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >C</span><span style=\"font-size: 16px;font-family: 宋体;\" >选项，其原因在于材料关键信息是“文明结婚”，学生往往会被“传统的婚姻观念……改变”这个信息所迷惑，而忽视了“完全”这个过于绝对的用词。</span></p></span>"
          },
          {
            "id": 19391214,
            "stem": "<p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >1907年10月13日，天津塘沽的张小田与北京慕贞女子书院的贾玉莲，在天津海大道美以美会微斯教堂，由陈牧师主持举行文明婚礼。报载“中西往贺者甚众。鲍太太按琴，男女学生唱诗，一时颇形热闹。礼毕，新夫妇乘双马车往北门外蓝家胡同张君本宅，并有成美学馆袁牧师夫妇及路矿等局诸友，均乘马车送新夫妇回家。”这一社会现象说明</span></p>",
            "options": {
              "A": "<span style=\"\" >传统婚俗已遭废除</span>",
              "B": "<span style=\"\" >年轻人崇尚西式婚礼</span>",
              "C": "<span style=\"\" >辛亥革命推动婚俗变革</span>",
              "D": "<span style=\"\" >政府倡导婚姻自主</span>"
            },
            "difficult": {
              "id": 3,
              "name": "一般"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-09-10T08:34:30",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [
              {
                "id": 10000,
                "name": "动荡中变化的近代社会生活",
                "pathIds": "9865,9998,9999,10000",
                "subjectId": 33
              }
            ],
            "childrenList": [

            ],
            "answer": "B",
            "analysis": "<span class=\"qml-general\"><span style=\"font-family: 宋体;\" >根据描述了1907年的一对婚礼的过程，可知采用的是新式婚礼的形式，说明西方的婚俗对中国有影响，但不能以此说明传统婚俗已被废除，故A项错误；通过这件事情可以得出年轻人对西式婚俗的认同，故B项正确；1907年辛亥革命尚未发生，故C项错误；材料没有体现此次婚姻与政府有关联，故D项错误。</span></span>"
          },
          {
            "id": 19684167,
            "stem": "<p style='text-indent: 28px;line-height: 24px;'><span style=\"font-size: 14px;font-family: 楷体;\" >阅读材料，完成下列要求。</span></p><p style='text-indent: 28px;line-height: 24px;'><span style=\"font-size: 14px;font-family: 楷体;\" >材料   下表为1950—2008年我国部分节假日一览表</span></p><table style=\"border-width:0px 0px 0px 0px;border-style:solid;border-color:black;border-collapse: collapse;\"><tr  height=\"31px\"><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2018/9/2/2023709452763136/2028167286882304/STEM/fb39fd9686f642b98d16ae2d29e8cc98.png\" width=\"97\" height=\"31\" /></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >1950</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >1995</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >2000</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >2008</span></p></td></tr><tr  height=\"31px\"><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >元旦</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >1</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >1</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >1</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >1</span></p></td></tr><tr  height=\"31px\"><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >春节</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >3</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >3</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >3</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >3</span></p></td></tr><tr  height=\"31px\"><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >劳动节</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >1</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >1</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >1</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >1</span></p></td></tr><tr  height=\"31px\"><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >国庆节</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >2</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >2</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >3</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >3</span></p></td></tr><tr  height=\"30px\"><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >星期日</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >1</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >1</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >1</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >1</span></p></td></tr><tr  height=\"31px\"><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >星期六</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >——</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >1</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >1</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >1</span></p></td></tr><tr  height=\"32px\"><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >清明节</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >——</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >——</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >——</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >1</span></p></td></tr><tr  height=\"31px\"><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >端午节</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >——</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >——</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >——</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >1</span></p></td></tr><tr  height=\"31px\"><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >中秋节</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >——</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >——</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >——</span></p></td><td style=\"width:98px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='margin-bottom: 13px;line-height: 24px;text-align: left;'><span style=\"font-family: 楷体;\" >1</span></p></td></tr></table><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >上表能够反映我国节假日变化的多种趋势。指出其中一种变化趋势并说明形成的历史原因。</span></p>",
            "options": null,
            "difficult": {
              "id": 3,
              "name": "一般"
            },
            "type": {
              "id": 3302,
              "name": "非选择题",
              "isSelectType": false
            },
            "updateTime": "2018-08-28T04:46:19",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [
              {
                "id": 26551,
                "name": "三 走向社会主义现代化建设新阶段",
                "pathIds": "26548,26551",
                "textbookId": 1178
              }
            ],
            "knowledgePoints": [
              {
                "id": 9982,
                "name": "伟大的历史转折——十一届三中全会",
                "pathIds": "9865,9967,9981,9982",
                "subjectId": 33
              },
              {
                "id": 9987,
                "name": "社会主义市场经济体制的确立",
                "pathIds": "9865,9967,9981,9987",
                "subjectId": 33
              },
              {
                "id": 10001,
                "name": "新中国社会生活新风尚",
                "pathIds": "9865,9998,9999,10001",
                "subjectId": 33
              }
            ],
            "childrenList": [

            ],
            "answer": "<span class=\"qml-an-sq\"><span class=\"qml-an\"><span style=\"font-size: 14px;font-family: 宋体;\" >评分说明：正确指出材料反映的一种变化趋势，如法定假日总天数从少到多，成为法定假日的传统节日种类增多，小长假出现和增多等，根据史世对变化趋势原因的说明充分恰当。</span><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >示例：</span></p><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >趋势：改革开放后法定假日总天数从少到多。</span></p><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >原因：实行改革开放，社会、经济发展迅速；人民生活水平不断提高，休闲娱乐需求增加；增加假日成为促进经济发展的一种手段；政府更加注重民生。</span></p></span></span>",
            "analysis": "<span class=\"qml-general\"><span style=\"font-family: 宋体;\" >本题是一道开放题，回答的时候只需要针对一个方面进行回答即可，这就给我们同学很大的发挥空间。所谓仁者见人，智者见智，只要观点不偏，针对材料的分析准确，就能够得到分数。根据图表，我们能够发现法定假日天数变多，传统节日作为法定假日开始增多。这是最容易发现的变化，也是同学最好回答的。针对原因，我们用四个字概括“合理即可”。所以这道题就看同学的发挥是否稳定，逻辑是否严密。</span><p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >【要点解密】</span></p><p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >这道题命题方式非常新颖，在新课标高考试卷中很少出现。回答时答案也是非常灵活自由，关键就是要看学生的答题思路，答题语言规范性。回答的时候先列举出变化趋势，之后再解释产生这种变化趋势的原因。回答原因的时候要分点回答，并且联系教材所学知识，给出你想法的理论基础。做到言之有物，分数很容易拿到。</span></p></span>"
          }
        ]
      };
    },
    name: 'introduce',
    mounted() {},
    methods: {}
  }
</script>
<style scoped>
</style>
<style>

  .paper-example{
    background-color: #ffffff;
    width: 1200px;
    margin: 60px auto;
    box-shadow:0px 5px 10px 0px rgba(0, 0, 0, 0.08);
    padding: 20px;
  }

  .paper-example h1{
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/front/introduce/history-paper/paper-example-2/index.vue